import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { toast } from 'react-toastify';
import { UploadIcon } from '../../features/UploadIcon';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField, FormLoading } from '../../shared/ui/FormLayout';

const EditCountriesGroupPage = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [icon, setIcon] = useState(null);
  const [form, setForm] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const getData = () => {
      apiRequests.countriesGroups.getById(id).then((res) => {
        setForm(res);
        if (res.iconPath) {
          setIcon(res.iconPath);
        }
      });
    };
    getData();
  }, [id]);

  const handleSubmit = async () => {
    if (!form?.title?.trim()) { toast.error('Введите название'); return; }
    setSaving(true);
    try {
      const formData = new FormData();
      if (icon && typeof icon !== 'string') formData.append('mainImg', icon);
      formData.append('model', JSON.stringify({ id: form.id, Title: form.title, LanguageEntityId: Number(form.languageEntityId) }));
      await apiRequests.countriesGroups.update(formData);
      toast.success('Группа стран обновлена');
      navigate('/general/countriesGroups');
    } catch { toast.error('Ошибка'); } finally { setSaving(false); }
  };

  if (!form) return <FormLoading />;

  return (
    <FormLayout onSubmit={handleSubmit} onBack={() => navigate('/general/countriesGroups')} saving={saving} submitText="Сохранить">
      <FormSection title="Основная информация">
        <Row>
          <Col md={6}>
            <FormField label="Название" required>
              <Form.Control type="text" value={form.title} onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))} placeholder="Группа стран" />
            </FormField>
          </Col>
          <Col md={6}>
            <LanguageOptions label="Основной язык" initialValue={form.languageEntityId} onSelect={(val) => setForm((prev) => ({ ...prev, languageEntityId: Number(val) }))} />
          </Col>
        </Row>
        <UploadIcon onSelect={setIcon} initialIcon={icon} entityType="countriesGroup" />
      </FormSection>
    </FormLayout>
  );
};

export default EditCountriesGroupPage;
